/**
 * @generated SignedSource<<38931832d8dab3bfe030bddecc73dbbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkDeletedValue_charge$data = {
  readonly id: string;
  readonly value: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentLinkDeletedValue_charge";
};
export type PaymentLinkDeletedValue_charge$key = {
  readonly " $data"?: PaymentLinkDeletedValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkDeletedValue_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkDeletedValue_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "0af1924d4ff90ae7fb8c15f76d3cf69d";

export default node;
